export class RoutePaths {
  static survey = {
    path: '/:surveyId/:clientId',
    onNavigate: (surveyId: string, clientId: string) => `/${surveyId}/${clientId}`,
  };
}
